import React from 'react'
import styled from 'styled-components'
import { FaCircleCheck } from "react-icons/fa6";
import { GoAlertFill } from "react-icons/go";

function Notifications({devices}) {
    const notification = devices?.disconnected || 0
    return (
        <Container>
            <p className='label'>Alertas recientes</p>
            {notification === 0 ?
            <div className='alert ok'>
                <div className="icon">
                    <FaCircleCheck />
                </div>
                <p className='title'>
                    No hay alertas
                </p>
                <p className='time'>
                    Ahora
                </p>
            </div>
            :
            <div className='alert error'>
                <div className="icon">
                    <GoAlertFill />
                </div>
                <p className='title'>
                    {notification} {notification === 1 ? 'medidor inactivo' : 'medidores inactivos'}
                </p>
                <p className='time'>
                    Hace 0 minutos
                </p>
            </div>
            }
            
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 90%;
    height: 27vh;
    gap: 10px;

    .label{
        color: #000;
        font-family: 'Montserrat', sans-serif;
        font-size: .8rem;
        font-style: normal;
        font-weight: 800;
        line-height: 120%;
    }
    .alert{
        width: 100%;
        height: 2.5rem;
        border-radius: 8px;

        display: grid;
        grid-template-columns: 1fr 15fr;
        grid-template-rows: repeat(2, 1fr);
        padding-left: 8px;
        grid-column-gap: 5px;
        grid-row-gap: 0px;

        .icon{
            grid-area: 1 / 1 / 3 / 2;
            display: flex;
            align-items: center;
            justify-content: center;
            svg{
                font-size: 24px;
            }
        }

        .title{
            grid-area: 1 / 2 / 2 / 3;
            margin: 0;
            margin-top: .2rem;

            color: #000;
            font-family: 'Montserrat', sans-serif;
            font-size: 0.8125rem;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
        }

        .time{
            grid-area: 2 / 2 / 3 / 3;
            margin: 0;
            color: #00000080;
            font-family: 'Montserrat', sans-serif;
            font-size: 0.8125rem;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
        }

        &.ok {
            background-color: #34C7594D;
            border-left: 8px solid #34C759;
            color: #34C759;
        }

        &.error {
            background-color: #FF3B304D;
            border-left: 8px solid #FF3B30;
            color: #FF3B30;
        }
    }

`

export default Notifications